import styled from "styled-components";

export const Svg = styled.svg`
  overflow: visible;
`;

export const Rect = styled.rect`
  transform: rotate(-45deg);
  transform-origin: center;
  fill: var(--icon-snow-fill, var(--snow));
`;

export const Node = styled.g`
  filter: ${props => `url(#shadow-${props.id})`};
  opacity: 1;
`;
